import { render, staticRenderFns } from "./ElectricMadMarket.vue?vue&type=template&id=70be3b8b&scoped=true"
import script from "./ElectricMadMarket.vue?vue&type=script&lang=js"
export * from "./ElectricMadMarket.vue?vue&type=script&lang=js"
import style0 from "./ElectricMadMarket.vue?vue&type=style&index=0&id=70be3b8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70be3b8b",
  null
  
)

export default component.exports